import Axios from "axios";
import qs from 'qs';

class Bridge {

    async POST(path, data, params = {}) {

      return Axios
        .post(`${process.env.REACT_APP_API_URL}/${path}`, data, {
          withCredentials: true,
          params: params,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets', encode: false })
        })
        .then(response => {
            this._resStatus(response.status);
            return response.data;
        })
        .catch(error => {
            this._resStatus(error.response.status);
            // eslint-disable-next-line
            if (error.code === "ERR_BAD_REQUEST") throw "Network issue";
            throw error;
        });

    };

    async GET(path, params = {}) {

      return Axios
        .get(`${process.env.REACT_APP_API_URL}/${path}`, {
          params: params,
          withCredentials: true,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets', encode: false })
        })

        .then(response => {
            this._resStatus(response.status);
            return response.data;
        })

        .catch(error => {
            this._resStatus(error.response.status);
            // eslint-disable-next-line
            if (error.code === "ERR_BAD_REQUEST") throw "Network issue";
            throw error;
        });
    };

    async PUT(path, data, params = {}) {

      return Axios
        .put(`${process.env.REACT_APP_API_URL}/${path}`, data, {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
          params: params,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets', encode: false })
        })
        .then(response => {
            this._resStatus(response.status);
            return response.data;
        })
        .catch(error => {
            // eslint-disable-next-line
            if (error.code === "ERR_BAD_REQUEST") throw "Network issue";
            throw error;
        });

    };

    async DELETE(path, params = {}) {

      return Axios
        .delete(`${process.env.REACT_APP_API_URL}/${path}`, {
          params: params,
          withCredentials: true,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets', encode: false })
        })

        .then(response => {
            this._resStatus(response.status);
            return response.data;
        })

        .catch(error => {

            // eslint-disable-next-line
            if (error.code === "ERR_BAD_REQUEST") throw "Network issue";
            throw error;
        });
    };

    _resStatus( statusCode ) {

        // eslint-disable-next-line
        switch (statusCode) {
            case 999: //Test
                // eslint-disable-next-line
                throw "All good, just test.";
            case 466:
                // eslint-disable-next-line
                throw "Code is not valid";
            case 467:
                // eslint-disable-next-line
                throw "Refresh Token is expired or invalid";
            case 470:
                // eslint-disable-next-line
                throw "Access Token is expired or invalid";
            case 471:
                // eslint-disable-next-line
                throw "Wrong password";
            case 472:
                // eslint-disable-next-line
                throw "You already have code generated";
            case 473:
                // eslint-disable-next-line
                throw "Failed to create session";
            case 474:
                // eslint-disable-next-line
                throw "Failed to sign refresh token";
            case 475:
                // eslint-disable-next-line
                throw "Failed to sign access token";
            case 476:
                // eslint-disable-next-line
                throw "User with this email and username was not found";
            case 477:
                // eslint-disable-next-line
                throw "User with this username already exists";
            case 478:
                // eslint-disable-next-line
                throw "User with this email already exists";
            case 479:
                // eslint-disable-next-line
                throw "You can't change your credentials once the code is sent";
            case 480:
                // eslint-disable-next-line
                throw "Database error 480";
            case 481:
                // eslint-disable-next-line
                throw "Database error 481";
            case 482:
                // eslint-disable-next-line
                throw "Database error 482";
            case 483:
                // eslint-disable-next-line
                throw "Database error 483";
            case 484:
                // eslint-disable-next-line
                throw "Database error 484";
            case 485:
                // eslint-disable-next-line
                throw "Database error 485";
            case 486:
                // eslint-disable-next-line
                throw "Database error 486";
            case 487:
                // eslint-disable-next-line
                throw "Database error 487";
            case 488:
                // eslint-disable-next-line
                throw "Database error 488";
            case 489:
                // eslint-disable-next-line
                throw "Database error 489";
            case 500:
                // eslint-disable-next-line
                throw "Internal Server Error";
        };
    };

};

export default Bridge;